import React, { PropsWithChildren } from 'react';
import * as S from './EmailConfirmationModal.styles';
import { Modal } from '@/components/UI/Modal';
import { BottomSheet } from '@/components/UI/BottomSheet/BottomSheet';
import { useResponsive } from '@/hooks/useResponsive';

interface EmailConfirmationShellProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
}

export function EmailConfirmationShell({
  children,
  isOpen,
  onClose,
  title,
}: PropsWithChildren<EmailConfirmationShellProps>) {
  const { isDesktop } = useResponsive();

  if (!isDesktop) {
    return (
      <BottomSheet
        isOpen={isOpen}
        close={onClose}
        title={title}
        isTitleCentered={false}
        hasHeadBorder={false}
        isPageLocked
        isInPortal
      >
        {children}
      </BottomSheet>
    );
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} maxWidth={500} isInPortal>
      <S.ModalContent>
        {title && (
          <S.ModalHeader>
            <S.ModalTitle>{title}</S.ModalTitle>
            <S.CloseButton type="button" onClick={onClose}>
              <S.CloseButtonIcon />
            </S.CloseButton>
          </S.ModalHeader>
        )}
        {children}
      </S.ModalContent>
    </Modal>
  );
}
